<template>
<w-sliding-popup type="setting" ref="slidingPopup" title="DB 설정 목록" width="700px" :default-content="false">
  <div class="body-content-no-scroll" style="height:100%; width:100%;" slot="content">
    <div class="vertical-center-box title-bar">
      <div class="title-h4 mr-r10">DB 목록</div>
      <div class="setting-addel">
        <el-button @click="onAddDbSettingButton"><i class="far fa-plus"></i></el-button>
        <el-button :disabled="!selectRowFlag" @click="onDelDbSettingButton"><i class="far fa-minus"></i></el-button>
      </div>
    </div>
    <el-table style="height: calc(100% - 38px);" ref="dbSettingTable" row-class-name="c-dblclick" @row-dblclick="onRowDblclick" :data="dbList"
    highlight-current-row @current-change="onChangeTableRow">
      <el-table-column header-align="center" prop="dbSettingId" label="ID"></el-table-column>
      <el-table-column header-align="center" prop="dbSettingName" label="DB접속명"></el-table-column>
    </el-table>
    <w-e2e-db-setting-info-popup ref="dbSettingInfoPopup" :db-type-list="dbTypeList" @load-data="loadData"></w-e2e-db-setting-info-popup>
  </div>
</w-sliding-popup>
</template>

<script>
import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';
import msgUtil from '@/utils/message';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import WE2eDbSettingInfoPopup from './E2eDbSettingInfoPopup';

export default {
  name: 'WE2eDbSettingSlidingPopup',
  components: {
    WE2eDbSettingInfoPopup,
  },
  props: {
    dbList: {
      type: Array,
      default: () => [],
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      selectRowFlag: false,
      dbTypeList: [],
    };
  },
  mounted() {
    // DBTYPE basicinfo
    basicinfoSubAPI.getList('DBTYPE').then((response) => {
      if (response.data.success) {
        this.dbTypeList = response.data.data;
      }
    });
  },
  methods: {
    loadData() {
      this.$emit('load-data');
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.selectRowFlag = false;
        this.$refs.dbSettingTable.setCurrentRow();
      });
    },
    // close 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    // DB 설정 추가 버튼
    onAddDbSettingButton() {
      // row highlight 해제
      // this.$refs.dbSettingTable.setCurrentRow();
      this.$refs.dbSettingInfoPopup.open('add');
    },
    onDelDbSettingButton() {
      const target = '데이터베이스 설정';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        // e2e정보도 함께 넘겨주어 삭제 시 e2e_trs_svc의 db정보도 삭제줘야한다.
        const params = {
          dbSettingId: this.formData.dbSettingId,
          serviceId: !isEmpty(this.serviceInfo) ? this.serviceInfo.objId : null,
          transactionId: !isEmpty(this.serviceInfo) ? this.serviceInfo.transactionId : null,
        };
        DeviceRegistrationE2eApi.deleteDbList(params)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.$emit('load-data', this.formData.dbSettingId);
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    onChangeTableRow(row) {
      this.selectRowFlag = false;
      if (row) {
        this.selectRowFlag = true;
        this.formData = cloneDeep(row);
      }
    },
    onRowDblclick(row) {
      this.$refs.dbSettingInfoPopup.open('update', row);
    },
  },
};
</script>

<style scoped>
.db-setting-form {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/popup/E2eDbSettingSlidingPopup.vue